const Search = () => import('@/pages/search/Search.vue');

export default [{
  path: '/search',
  name: 'search',
  meta: {
    isLogin: false
  },
  component: Search
}, ]